export default __webpack_public_path__ + "static/media/join-as-a-coach.706f9af2.png";